import PatchCornerType from "../../../../enums/patchCornerTypes"
import SectionType from "../../../../enums/sectionType"
import { ASSET_TYPES } from "../../../../utils/constants"
import { PatchOverviewFormProps } from "./PatchOverviewForm.types"
// import "./OverviewForm.css"

const PatchOverviewForm = (props: PatchOverviewFormProps) => {
  const { workflow } = props

  return (
    <div className="overview-form-container">
      <h2>Workflow Overview</h2>
      <div className="overview-container">
        <h3>Workflow Details</h3>
        <div className="workflow-overview">
          <p>Workflow Filename:</p>
          <p>{workflow.filename}</p>
          <p>Asset ID:</p>
          <p>{workflow.asset_id}</p>
          <p>Asset Temperature:</p>
          <p>{workflow.asset_temp}</p>
          <p>Location</p>
          <p>{workflow.location}</p>
          <p>Asset type:</p>
          <p>{ASSET_TYPES[workflow.asset_type].name}</p>

          <p>Cladding material:</p>
          <p>{workflow.cladding_material}</p>
          <p>Cladding thickness:</p>
          <p>{workflow.cladding_thickness}</p>
          <p>Insulation material:</p>
          <p>{workflow.insulation_material}</p>
          <p>Insulation thickness:</p>
          <p>{workflow.insulation_thickness}</p>
        </div>
      </div>

      {JSON.parse(workflow.sections).map((section: number[], index: number) => (
        <div className="overview-container">
          <h3>{`Section ${index+1}`}</h3>
          <div className="section-overview" key={index}>
            <p>Section width:</p>
            <p>{section[0]}</p>
            <p>Section height:</p>
            <p>{section[1]}</p>
            <p>Scan Reset Position:</p>
            <p>{Object.values(PatchCornerType)[section[2]]}</p>
            <p>Positions:</p>
            <p>{JSON.parse(workflow.horizontal_positions)[index].map((position: number) => `${position}mm, `)}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default PatchOverviewForm